import { createAction } from 'typesafe-actions';

import { Integrations } from '../constants';

interface ISourceIdPayload {
  sourceId: $TSFixMe;
}

type StartingSourceParams = ISourceIdPayload;
export const startingSource = createAction(
  Integrations.ActionTypes.STARTING_SOURCE,
  (params: StartingSourceParams) => params,
)<StartingSourceParams>();
export type StartingSourceAction = ReturnType<typeof startingSource>;

type SourceStartedParams = ISourceIdPayload;
export const sourceStarted = createAction(
  Integrations.ActionTypes.SOURCE_STARTED,
  (params: SourceStartedParams) => params,
)<SourceStartedParams>();
export type SourceStartedAction = ReturnType<typeof sourceStarted>;

type StartSourceIncompleteParams = ISourceIdPayload;
export const startSourceIncomplete = createAction(
  Integrations.ActionTypes.START_SOURCE_INCOMPLETE,
  (params: StartSourceIncompleteParams) => params,
)<StartSourceIncompleteParams>();
export type StartSourceIncompleteAction = ReturnType<typeof startSourceIncomplete>;

interface TrackStartedFromSourceParams extends $TSFixMe {}

export const newTrackStartedFromSource = createAction(
  Integrations.ActionTypes.TRACK_STARTED_FROM_SOURCE,
  (params: TrackStartedFromSourceParams) => params,
)<TrackStartedFromSourceParams>();
export type TrackStartedFromSourceAction = ReturnType<typeof newTrackStartedFromSource>;

interface TrackInterruptedParams {
  previousSourceId: $TSFixMe;
  previousType: $TSFixMe;
  previousTrack: $TSFixMe;
}

export const trackInterrupted = createAction(
  Integrations.ActionTypes.TRACK_INTERRUPTED,
  (params: TrackInterruptedParams) => params,
)<TrackInterruptedParams>();
export type TrackInterruptedAction = ReturnType<typeof trackInterrupted>;

interface FeedbackAddedParams {
  sourceId: $TSFixMe;
  trackToken: $TSFixMe;
  isPositive: $TSFixMe;
}

export const feedbackAdded = createAction(
  Integrations.ActionTypes.FEEDBACK_ADDED,
  (params: FeedbackAddedParams) => params,
)<FeedbackAddedParams>();
export type FeedbackAddedAction = ReturnType<typeof feedbackAdded>;

interface FeedbackRemovedParams {
  sourceId: $TSFixMe;
  trackToken: $TSFixMe;
  isPositive: $TSFixMe;
}

export const feedbackRemoved = createAction(
  Integrations.ActionTypes.FEEDBACK_REMOVED,
  (params: FeedbackRemovedParams) => params,
)<FeedbackRemovedParams>();
export type FeedbackRemovedAction = ReturnType<typeof feedbackRemoved>;

interface ComponentClickedParams extends $TSFixMe {}

export const componentClicked = createAction(
  Integrations.ActionTypes.COMPONENT_CLICKED,
  (params: ComponentClickedParams) => params,
)<ComponentClickedParams>();
export type ComponentClickedAction = ReturnType<typeof componentClicked>;

interface ComponentViewedParams extends $TSFixMe {}

export const componentViewed = createAction(
  Integrations.ActionTypes.COMPONENT_VIEWED,
  (params: ComponentViewedParams) => params,
)<ComponentViewedParams>();
export type ComponentViewedAction = ReturnType<typeof componentViewed>;

export const signUpClicked = createAction(Integrations.ActionTypes.SIGN_UP_CLICKED)();
export type SignUpClickedAction = ReturnType<typeof signUpClicked>;

export const logInClicked = createAction(Integrations.ActionTypes.LOG_IN_CLICKED)();
export type LogInClickedAction = ReturnType<typeof logInClicked>;

export const viewPlansClicked = createAction(Integrations.ActionTypes.VIEW_PLANS_CLICKED)();
export type ViewPlansClickedAction = ReturnType<typeof viewPlansClicked>;

export const appStoreClicked = createAction(Integrations.ActionTypes.APP_STORE_CLICKED)();
export type AppStoreClickedAction = ReturnType<typeof appStoreClicked>;

interface ImageFetchErroredParams extends $TSFixMe {}

export const imageFetchErrored = createAction(
  Integrations.ActionTypes.IMAGE_FETCH_ERRORED,
  (params: ImageFetchErroredParams) => params,
)<ImageFetchErroredParams>();
export type ImageFetchErroredAction = ReturnType<typeof imageFetchErrored>;

interface GraphqlFetchedParams extends $TSFixMe {}

export const graphQLFetched = createAction(
  Integrations.ActionTypes.GRAPHQL_FETCHED,
  (params: GraphqlFetchedParams) => params,
)<GraphqlFetchedParams>();
export type GraphqlFetchedAction = ReturnType<typeof graphQLFetched>;
